const session = {
  title: "Quiz",
  incorrectOnly: "(Incorrect Only)",
  completed: "Quiz Complete!",
  resultSummary: "You got {{correctCount}} out of {{totalCount}} questions correct.",
  feedbackExcellent: "Excellent! You understood the material well!",
  feedbackGood: "Good! A little more review and you'll be perfect!",
  feedbackEncourage: "That's okay! Study again and try once more!",
  retake: "Retake",
  done: "Done",
  previous: "Previous",
  next: "Next",
  jumpToQuestion: "Jump to Question",
  failedToLoad: "Failed to load quiz.",
  retry: "Retry",
  noIncorrectQuestions: "No incorrect questions.",
  noQuizForContent: "No quiz is associated with this content."
};
const container = {
  checkAnswerError: "An error occurred while checking answers. Please try again later.",
  unsupportedType: "This question type ({{type}}) is not yet supported.",
  questionNumber: "Q{{number}}",
  correctRate: "Correct rate: {{rate}}%",
  containsVariables: "Contains variables: {{variables}}",
  questionImage: "Question Image",
  submitting: "Submitting...",
  checkAnswer: "Check Answer"
};
const types = {
  boolean: {
    label: "True or False",
    correct: "True",
    incorrect: "False",
    selectLabel: "Select True or False"
  },
  fillBlank: {
    label: "Fill in the Blank",
    placeholder: "blank",
    answer: "Answer:",
    hint: "Hint:"
  },
  dragText: {
    label: "Fill Boxes",
    blank: "?",
    "delete": "Delete",
    selectFromChoices: "Select from choices:"
  },
  selectText: {
    label: "Select",
    placeholder: "?",
    answer: "Answer:"
  },
  multiChoice: {
    label: "Multi Choice",
    selectCount: "Select {{count}}",
    selectInstruction: "Select {{count}} ({{selected}}/{{count}} selected)",
    selectOne: "Select one",
    optionAlt: "Option {{number}}",
    selectOption: "Select option"
  },
  inline: {
    label: "Inline",
    childLabel: "Question {{n}}",
    partialResult: "{{correct}} of {{total}} correct"
  },
  coloring: {
    label: "Coloring",
    correctAnswerErase: "The answer is to erase {{count}}.",
    correctAnswerColor: "The answer is to color {{count}}.",
    erased: "Erased {{count}}.",
    colored: "Colored {{count}}.",
    eraseCount: "Erase {{count}}",
    colorCount: "Color {{count}}"
  },
  counting: {
    label: "Counting",
    incrementDigit: "Increment digit {{position}}",
    decrementDigit: "Decrement digit {{position}}"
  },
  ordering: {
    label: "Ordering",
    dragInstruction: "Drag to reorder",
    moveUp: "Move up",
    moveDown: "Move down"
  },
  pairing: {
    label: "Pairing",
    matchPairs: "Match the pairs",
    selectMatch: "Select a match"
  },
  imageSelect: {
    label: "Image Select",
    selectArea: "Select an area"
  },
  newFillBlank: {
    label: "Short Answer",
    note: "※ Your answer will be available in the AIQ report after course completion.",
    placeholder: "Type your answer here...",
    submit: "Submit",
    submitted: "Your answer has been submitted."
  },
  newMultiChoice: {
    label: "Multi Choice",
    selectCount: "Select {{count}}",
    selectedProgress: "{{selected}}/{{count}} selected",
    selectOption: "Select an option",
    submit: "Submit",
    submitted: "Your answer has been submitted."
  },
  newSelectText: {
    label: "Select Text",
    selectOption: "Select Text",
    submit: "Submit",
    submitted: "Your answer has been submitted."
  }
};
const feedback = {
  correct: "Correct!",
  correctMessage: "Good job, keep it up!",
  incorrect: "Incorrect",
  submitted: "Submitted",
  submittedMessage: "Your teacher is reviewing your answer.",
  explanation: "Explanation"
};
const common = {
  checkAnswer: "Check Answer",
  viewMyAnswer: "View My Answer",
  viewCorrectAnswer: "View Correct Answer",
  correct: "Correct",
  score: "Score: {{score}} pts",
  scorePoints: "{{score}} pts",
  feedbackCorrect: "Great job! Try the next question!",
  feedbackIncorrect: "That's okay. Read the explanation and try again!",
  optionAlt: "Option {{number}}"
};
const overlay = {
  warmupQuiz: "Warm-up Questions",
  reviewQuiz: "Review Questions",
  moduleStartQuiz: "Module Start Quiz",
  moduleEndQuiz: "Module End Quiz",
  startQuiz: "Start Quiz",
  endQuiz: "End Quiz"
};
const shared = {
  blank: "blank",
  explanation: "Explanation",
  explanationImage: "Explanation Image",
  cannotLoadGraph: "Unable to load graph: {{error}}",
  cannotLoadVideo: "Unable to load video.",
  copyQuizId: "Copy Quiz ID",
  viewInAdmin: "View quiz in Admin"
};
const toggle = {
  correctAndExplanation: "Answer & Steps",
  myAnswer: "My Answer"
};
const result = {
  popup: {
    correctAriaLabel: "Correct",
    correctComboAriaLabel: "3 correct in a row",
    wrongAriaLabel: "Incorrect",
    wrongComboAriaLabel: "3 wrong in a row"
  }
};
const quizEn = {
  session,
  container,
  types,
  feedback,
  common,
  overlay,
  shared,
  toggle,
  result
};
export {
  common,
  container,
  quizEn as default,
  feedback,
  overlay,
  result,
  session,
  shared,
  toggle,
  types
};
//# sourceMappingURL=quiz.json.js.map
